import { FileSelectContextProvider } from '@/components/SharepointFileTree';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import SelectedFilesList from './SelectedFilesList';

export const SharepointFileSelectDialog = ({
	open,
	onClose,
	onConfirm,
	itemId,
	driveId,
	disableParent = false,
	multiple = true,
	types,
	title = 'Select files to attach',
	hideBackdrop = false,
}) => {
	const [selectedFiles, setSelectedFiles] = useState([]);

	useEffect(() => {
		if (!open) {
			setSelectedFiles([]);
		}
	}, [open]);

	const handleClose = () => {
		setSelectedFiles([]);
		onClose();
	};

	const handleConfirm = () => {
		onConfirm(selectedFiles);
		handleClose();
	};

	const hasSelection = selectedFiles.length > 0;

	return (
		<Dialog open={open} onClose={handleClose} hideBackdrop={hideBackdrop} fullWidth>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent sx={{ paddingBottom: '2em' }}>
				<Stack spacing={3}>
					<FileSelectContextProvider
						selectedFiles={selectedFiles}
						setSelectedFiles={setSelectedFiles}
						itemId={itemId}
						driveId={driveId}
						disableParent={disableParent}
						multiple={multiple}
						types={types}
					/>
					<SelectedFilesList selectedFiles={selectedFiles} onChange={setSelectedFiles} />
				</Stack>
			</DialogContent>

			<DialogActions>
				<Button onClick={handleClose} color='primary'>
					Cancel
				</Button>
				<Button
					disabled={!hasSelection}
					variant='contained'
					color='primary'
					onClick={handleConfirm}
				>
					Attach {selectedFiles.length} {selectedFiles.length === 1 ? 'file' : 'files'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SharepointFileSelectDialog;
